import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const elementExposureRow = ({
  index,
  percentage,
  theme,
}: {
  index: number
  percentage: number
  theme: Theme
}) => css`
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  top: ${Math.min(10, index) * 36}px;
  transition:
    top 0.4s,
    opacity 0.2s;
  opacity: ${index < 10 ? 1 : 0};
  pointer-events: ${index < 10 ? 'auto' : 'none'};
  user-select: none;
  overflow: hidden;
  gap: 8px;

  &:hover .td .bar-label {
    .metrics {
      opacity: 1;
      transform: translateX(0);
    }
    .percentage {
      opacity: 0;
      transform: translateX(6px);
    }
  }
  .td {
    padding-top: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    line-height: 130%;
    position: relative;

    &:hover {
      .bar {
        background-color: ${theme.palette.uintel.light};
      }

      .bar-label {
        color: ${theme.palette.uintel.light};
      }
    }

    .bar {
      transition: width 0.4s;
      width: ${percentage * 0.8}%;
      height: 24px;
      background-color: ${theme.palette.uintel.main};
      margin-right: 8px;
      flex-shrink: 0;
      transition: background-color 0.1s;
    }

    .bar-label {
      position: absolute;
      font-size: 12px;
      left: ${percentage * 0.8}%;
      background-color: ${percentage > 0.5 ? theme.palette.white.main : 'transparent'};
      padding: 2px 0 4px 4px;
      margin: 0 4px;
      color: ${theme.palette.uintel.main};
      font-weight: 700;
      white-space: nowrap;
      height: 100%;
      display: flex;
      align-items: center;
      transition:
        opacity 0.2s,
        transform 0.2s;

      .percentage {
        transition:
          opacity 0.1s,
          transform 0.2s;
        opacity: 1;
        transform: translateX(0);
        position: absolute;
      }

      .metrics {
        position: absolute;
        font-weight: 400;
        opacity: 0;
        transform: translateX(-6px);
        transition:
          opacity 0.1s,
          transform 0.2s;
      }
    }
  }
`

export const elementExposureList = (exposurePercIsLoading: boolean) => css`
  width: 100%;
  height: 360px;
  margin-top: 8px;
  position: relative;
  transition: opacity 0.3s;
  opacity: ${exposurePercIsLoading ? 0.3 : 1};
`
